import { createStructuredSelector } from 'reselect';
import {
  SUP_VEHICLE_LIST, SUP_VEHICLE_LIST_SUCCESS, SUP_VEHICLE_LIST_ERROR,
  SUP_VEHICLE_PAGE_SET,
  SUP_VEHICLE_ADD, SUP_VEHICLE_ADD_SUCCESS, SUP_VEHICLE_ADD_ERROR,
  SUP_VEHICLE_ADD_CHANGE,
  SUP_VEHICLE_DETAIL, SUP_VEHICLE_DETAIL_SUCCESS, SUP_VEHICLE_DETAIL_ERROR,
  SUP_VEHICLE_UPDATE, SUP_VEHICLE_UPDATE_SUCCESS, SUP_VEHICLE_UPDATE_ERROR,
  SUP_VEHICLE_FILTER_TYPE, SUP_VEHICLE_FILTER_TYPE_SUCCESS,
  SUP_VEHICLE_FILTER_SUPPLIERS, SUP_VEHICLE_FILTER_SUPPLIERS_SUCCESS,
} from '../../actions';

export const NAME = 'sup_vehicle';

export const SupplierVehicleList = (page, num_page, orderBy, filters) => ({ type: SUP_VEHICLE_LIST, payload: { page, num_page, orderBy, filters } });
export const SupplierVehicleListSuccess = (data) => ({ type: SUP_VEHICLE_LIST_SUCCESS, payload: data });
export const SupplierVehicleListError = (error) => ({ type: SUP_VEHICLE_LIST_ERROR, payload: error });
export const SupplierVehiclePageSet = (data) => ({ type: SUP_VEHICLE_PAGE_SET, payload: data });
export const SupplierVehicleAddChangeSet = (data) => ({ type: SUP_VEHICLE_ADD_CHANGE, payload: data });
export const SupplierVehicleAdd = (data) => ({ type: SUP_VEHICLE_ADD, payload: data });
export const SupplierVehicleAddSuccess = (message) => ({ type: SUP_VEHICLE_ADD_SUCCESS, payload: message });
export const SupplierVehicleAddError = (error) => ({ type: SUP_VEHICLE_ADD_ERROR, payload: error });
export const SupplierVehicleDetail = (data) => ({ type: SUP_VEHICLE_DETAIL, payload: data });
export const SupplierVehicleDetailSuccess = (data) => ({ type: SUP_VEHICLE_DETAIL_SUCCESS, payload: data });
export const SupplierVehicleDetailError = (error) => ({ type: SUP_VEHICLE_DETAIL_ERROR, payload: error });
export const SupplierVehicleUpdate = (data) => ({ type: SUP_VEHICLE_UPDATE, payload: data });
export const SupplierVehicleUpdateSuccess = (message) => ({ type: SUP_VEHICLE_UPDATE_SUCCESS, payload: message.message });
export const SupplierVehicleUpdateError = (error) => ({ type: SUP_VEHICLE_UPDATE_ERROR, payload: error });
export const SupplierVehicleFilterType = () => ({ type: SUP_VEHICLE_FILTER_TYPE });
export const SupplierVehicleFilterTypeSuccess = (data) => ({ type: SUP_VEHICLE_FILTER_TYPE_SUCCESS, payload: data });
export const SupplierVehicleFilterSuppliers = () => ({ type: SUP_VEHICLE_FILTER_SUPPLIERS });
export const SupplierVehicleFilterSuppliersSuccess = (data) => ({ type: SUP_VEHICLE_FILTER_SUPPLIERS_SUCCESS, payload: data });

const sup_vehicle = (state) => state[NAME];
export const SupplierVehicleSelector = createStructuredSelector({ sup_vehicle });
